import { Map, List } from 'immutable';

import { prepareTrendsTestsData } from '../../../../util';

export const createTestsReducer = (types) => {
  const initialState = Map({
    loading: false,
    testsCountData: List(),
    statusCountData: List(),
    totalTests: 0,
    passedRate: 0,
  });

  const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case types.GET_TEST_TRENDS.REQUEST:
        return state.set('loading', true);
      case types.GET_TEST_TRENDS.SUCCESS:
        return state.withMutations((newState) => {
          const {
            testsCountData, statusCountData, totalTests, totalPassedTests,
          } = prepareTrendsTestsData(payload);
          newState
            .set('loading', false)
            .set('testsCountData', List(testsCountData))
            .set('statusCountData', List(statusCountData))
            .set('totalTests', totalTests)
            .set('passedRate', (totalPassedTests / totalTests) * 100);
        });
      case types.GET_TEST_TRENDS.FAILURE:
      case types.CLEAN_UP:
        return initialState;
      default:
        return state;
    }
  };

  return { reducer, initialState };
};
